import { render, staticRenderFns } from "./main.vue?vue&type=template&id=a260f614&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style1 from "./main.vue?vue&type=style&index=1&id=a260f614&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a260f614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a260f614')) {
      api.createRecord('a260f614', component.options)
    } else {
      api.reload('a260f614', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=a260f614&scoped=true", function () {
      api.rerender('a260f614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/edit/main.vue"
export default component.exports